import { render, staticRenderFns } from "./banner4.vue?vue&type=template&id=fee1ae4c&scoped=true"
import script from "./banner4.vue?vue&type=script&lang=js"
export * from "./banner4.vue?vue&type=script&lang=js"
import style0 from "./banner4.vue?vue&type=style&index=0&id=fee1ae4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee1ae4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fee1ae4c')) {
      api.createRecord('fee1ae4c', component.options)
    } else {
      api.reload('fee1ae4c', component.options)
    }
    module.hot.accept("./banner4.vue?vue&type=template&id=fee1ae4c&scoped=true", function () {
      api.rerender('fee1ae4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/bannerTemplate/banner4.vue"
export default component.exports